import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/Rx';

import {
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../../global';
import {Platform} from './platform.model';

@Injectable()

export class PlatformService {

  constructor(private http: HttpClient) {
  }

  getPlatforms (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/platforms', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getPlatform (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/platform/' + reference)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postPlatform (platform: Platform) {

    const body = Object.assign({}, platform);
    delete body.reference;

    return this.http.post(GlobalVariable.BASE_API_URL + '/platforms', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  setAsDefaultPlatform (platform: Platform) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/platform/' + platform.reference + '/make-default')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putPlatform (platform: Platform) {

    const body = Object.assign({}, platform);
    delete body.reference;

    return this.http.put(GlobalVariable.BASE_API_URL + '/platform/' + platform.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  patchPlatform (platform: Platform) {

    const body = Object.assign({}, platform);
    delete body.reference;

    return this.http.patch(GlobalVariable.BASE_API_URL + '/platform/' + platform.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deletePlatform (platform: Platform) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/platform/' + platform.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/parameters/platforms/platform.service.ts